





















































import {Component, Vue, Watch} from "vue-property-decorator";
import {LadingCareParams} from "@/modules/ladingcare/params";
import {LadingCareStatus} from "@/enums/status/ladingcare";
import debounce from "lodash/debounce";
import {LadingCareStore} from "@/modules/ladingcare/store";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import EmployeeCareSelector from "@/shared/components/EmployeeCareSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import {allLadingCare} from "@/modules/ladingcare/services";
import {LadingStatus} from "@/enums/status";
import TableToExcel from "@linways/table-to-excel";
import LadingCareExcel from "@/modules/ladingcare/List/components/Excel.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
@Component({
  name: "LadingCareSearch",
  components: {LadingCareExcel, EnumSelector,EmployeeSelector, EmployeeCareSelector, CustomerSelector, MillisecondDatePicker, PostOfficeSelector}
})
export default class extends Vue {
    form = new LadingCareParams();
    LadingStatus = LadingStatus;
    EmployeeType = EmployeeType;
    LadingCareStatus = LadingCareStatus;
    isExporting = false;
    dataSourceExcel = [] as any;

    @Watch('form', {immediate: false, deep: true})
    onValueChange(val: any) {
        this.handleChange(val)
    }
    
    handleChange = debounce(function (val) {
        LadingCareStore.updateLadingCareParams(val)
        LadingCareStore.listLadingCare({...val, page: 1})
    }, 500)

    async exportExcel() {
        try {
            this.isExporting = true;
            const response = await allLadingCare(this.form);
            if (response.data.datas && response.data.datas.length > 0) {
                this.dataSourceExcel = response.data.datas;
                console.log("data care excel: ",this.dataSourceExcel);
                setTimeout(() => {
                    TableToExcel.convert(document.getElementById("table-excel-lading-care"), {
                        name: `Chăm sóc đơn hàng.xlsx`,
                        sheet: {
                            name: "Sheet 1"
                        }
                    });
                }, 200)
            } else {
                this.$message.warning("Không có dữ liệu để export");
            }
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã có lỗi xảy ra");
        } finally {
            this.isExporting = false;
        }
    }
}
